import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright } from "react-icons/io";
import overlay from "../assets/overlay.jpg";

export default function HomeBanner2() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }

  return (
    <section
      className="MainBodySection"
      style={{
        padding: "90px 0",
        backgroundImage: `url(${overlay})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      {/* overlay tint */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(0,0,0,0.55)",
        }}
      />

      <div className="container position-relative">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div
              className="p-5"
              style={{
                background: "rgba(255,255,255,0.92)",
                borderRadius: "22px",
                boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Title */}
              <h1
                className="text-primary font-bold mb-4"
                style={{ letterSpacing: "0.4px" }}
              >
                Kitchen Kings
              </h1>

              {/* About Us Summary */}
              <p
                className="font-light mb-5"
                style={{ fontSize: "18px", lineHeight: "1.8", color: "#333" }}
              >
                At Kitchen Kings TZ, we design and craft high-quality kitchens, custom furniture, and furnishing solutions that combine style, durability, and functionality. 
                <br /><br />
                Our mission is to transform living and working spaces with innovative, sustainable designs while prioritizing quality, safety, and customer satisfaction. 
                <br /><br />
                We serve homeowners, contractors, interior designers, restaurants, hospitality businesses, and property developers across Mwanza and East Africa, delivering tailored solutions for every project. 
                <br /><br />
                Guided by our core values—integrity, teamwork, innovation, sustainability, and excellence—we strive to create spaces that inspire and endure.
              </p>

              {/* CTA */}
              <div>
                <button
                  className="border-0 btn-primary"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "14px",
                    padding: "14px 22px",
                    borderRadius: "999px",
                    color: "#fff",
                    fontWeight: 600,
                    transition: "all 0.35s ease",
                  }}
                  onClick={() => appContext.navTo({ item: "about_us" })}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateX(6px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateX(0)";
                  }}
                >
                  Learn More
                  <IoMdArrowDropright size={26} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
